import React, { useState } from 'react'
import "./Calendar.css"
import { Calendar, dateFnsLocalizer } from 'react-big-calendar'
import format from "date-fns/format"
import parse from "date-fns/parse"
import startOfWeek from "date-fns/startOfWeek"
import getDay from "date-fns/getDay"
import DatePicker from "react-datepicker"
import "react-big-calendar/lib/css/react-big-calendar.css"
import "react-datepicker/dist/react-datepicker.css"
import CloseIcon from '@mui/icons-material/Close';


const locales = {
  "en-US" : require("date-fns/locale/en-US")
}

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales
})

const events = [
  {
    title : 'Big Meeting',
    allDay : true,
    start : new Date(2023,12,8),
    end : new Date(2023,12,8)
  },
  {
    title : 'Vacation',
    start : new Date(2023,12,8),
    end : new Date(2023,12,8)
  }
]

export default function Calendars() {

  const [addEvent, setAddEvent] = useState(false)
  const [newEvents, setNewEvents] = useState({title: "", start: "", end: ""})
  const [allEvents, setAllEvents] = useState(events)

  function handleAddEvents () {
    setAllEvents([...allEvents, newEvents])
  }

  return (
    <div className='calendar'>
      <div className="calendar-top">
        <h1>Calendar</h1>
        <div className='calendar-btn'>
          <button onClick={()=> setAddEvent(true)}>+Add Events</button>
        </div>
        {
          addEvent && <div className='calendar-add'>
          <div className="calendar-wrapper">
            <div className="calendar-closeBtn">
              <button onClick={() => setAddEvent(false)} className='calendar-close'><CloseIcon/></button>
            </div>
            <h2>Add New Events</h2>
            <input type="text" placeholder='Add title'
            value={newEvents.title} onChange={(e) => setNewEvents({...newEvents, title: e.target.value})}/>
            <DatePicker placeholderText='Start Date' selected={newEvents.start}
            onChange={(start) => setNewEvents({...newEvents, start})}/>
            <DatePicker placeholderText='End Date' selected={newEvents.end}
            onChange={(end) => setNewEvents({...newEvents, end})}/>
            <button className='calendar-addBtn' onClick={handleAddEvents}>Add Events</button>
          </div>
        </div>
        }
      </div>
      <Calendar localizer={localizer} events={allEvents} startAccessor="start" endAccessor="end" style={{ height: 700, margin: "50px"}}/>
    </div>
  )
}
